import React from 'react';
import {
  Table as MuiTable,
  TableBody as MuiTableBody,
  TableCell as MuiTableCell,
  TableContainer as MuiTableContainer,
  TableHead as MuiTableHead,
  TableRow as MuiTableRow,
} from '@mui/material';
import styled from 'styled-components';

// This re-purposes the Vet Reseller's PersonnelTable component to be a generic table component (app/javascript/components/VetReseller/components/PersonnelTable/)
// Usage:
// import { Table } from 'components/shared/Table'
//
// <Table>
//   <Table.TableHead>
//     <Table.TableRow>
//       <Table.TableCell>First Name</Table.TableCell>
//       <Table.TableCell>Last Name</Table.TableCell>
//     </Table.TableRow>
//   </Table.TableHead>
//   <Table.TableBody>
//     <Table.TableRow>
//       <Table.TableCell>John</Table.TableCell>
//       <Table.TableCell>Doe</Table.TableCell>
//       <Table.RowActionsCell>
//         <RowActions onRemove={onRowRemove} row={row} rowIndex={index} openEditModal={openEditModal}/>
//       </Table.RowActionsCell>
//     </Table.TableRow>
//     <Table.TableActionsRow>
//        <Table.TableCell><YourActionPerformer /></Table.TableCell>
//     </Table.TableActionsRow>
//   </Table.TableBody>
// </Table>

export const Table = styled(MuiTable)`
  margin-bottom: 0;

  @media (max-width: 800px) {
    /* Force table to not be like tables anymore */
    table,
    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    /* Hide table headers (but not display: none;, for accessibility) */
    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    tr {
      border: 1px solid #ccc;
      background-color: transparent;
    }

    td {
      /* Behave  like a "row" */
      border: none;
      position: relative;
      padding-left: 40%;
      white-space: normal;
      text-align: left;
      line-height: 1.2;
    }

    td:before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      left: 6px;
      width: 35%;
      padding-right: 10px;
      white-space: nowrap;
      text-align: right;
      font-family: 'Whitney Medium';
    }

    /*
    Label the data. add data-label attributes to the <td data-label="Name">John</td>
    */
    td::before {
      content: attr(data-label);
    }

    tr:nth-child(even) {
      background-color: #f2f2f2;
    }

    tr:last-child {
      background-color: white;
    }
  }
`;

Table.TableCell = MuiTableCell;
Table.TableRow = MuiTableRow;
Table.Container = styled(MuiTableContainer)`
  border-radius: 0;
  box-shadow: none;
`;

Table.TableHead = styled(MuiTableHead)`
  border: none;
  background-color: transparent;

  .MuiTableCell-head {
    border: none;
    font-family: 'Whitney Medium';
    font-size: 1rem;
    padding-bottom: 4px;

    &.ownership {
      display: inline-grid;
      margin-left: -1.85rem;
      padding-right: 0;
      padding-left: 0;
    }

    &:first-of-type {
      padding-left: 0;
    }
  }
`;

Table.TableActionsRow = styled(MuiTableRow)`
  div {
    align-items: center;
    cursor: pointer;
    display: grid;
    grid-column-gap: 1rem;
    grid-template-columns: auto 1fr;

    span {
      color: #006c9c;
      font-family: 'Whitney Bold';
      font-size: 1rem;

      &:hover {
        color: #004766;
      }
    }
  }

  @media (max-width: 800px) {
    td {
      padding-left: 1rem;
    }
  }
`;

Table.RowActionsCell = styled(MuiTableCell)`
  align-items: center;
  cursor: pointer;
  width: 100px;

  @media (max-width: 800px) {
    display: grid !important;
    width: inherit;
  }

  span {
    color: #006c9c;
    font-family: 'Whitney Bold';
    font-size: 1rem;

    &.delete {
      color: #bf1e2d;

      &:hover {
        color: #004766;
      }
    }

    &:hover {
      color: #004766;
    }
  }

  svg {
    color: #272727;

    &:hover {
      color: #bf1e2d;
    }
  }
`;

Table.TableBody = styled(MuiTableBody)`
  border: 1px solid #888888;
  border-radius: 0;

  .MuiTableRow-root {
    background-color: transparent;
    border-bottom: 1px solid #dfe3e6;

    @media (max-width: 800px) {
      background-color: transparent !important;
    }

    &:last-of-type {
      border: none;
    }
  }

  .MuiTableCell-root {
    border: none;
    font-family: 'Whitney Book';
    font-size: 1rem;
  }

  .license-number {
    max-width: 125px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 800px) {
      max-width: inherit;
      width: inherit;
    }
  }

  .practice-roles {
    max-width: 180px;
    height: 51px;
    overflow: hidden;
    padding-right: 0;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 800px) {
      height: inherit;
      max-width: inherit;
      width: inherit;
    }
  }

  .email {
    max-width: 120px;
    overflow: hidden;
    padding-right: 0;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 800px) {
      max-width: inherit;
    }
  }

  .ownership {
    padding-right: 0;
    padding-left: 0;
    width: 62px;

    @media (max-width: 800px) {
      padding-left: 40%;
      width: inherit;
    }
  }
`;
